import React, {useContext} from 'react';
import FormField, {Props} from '@src/components/Form/FormField';
import {ITechOperationModel} from '@src/@interfaces/models/TechOperation/ITechOperationModel';
import {FormDataProviderAPIContext} from '@src/contexts/FormDataProviderAPIContext';
import TechOperationSelect from '@views/tech-operations/fields/TechOperationSelect';

function ActualForm(props: Props<ITechOperationModel>) {
    const {modelOptions = {}} = useContext(FormDataProviderAPIContext) ?? {};

    return <TechOperationSelect {...props} options={modelOptions.operations}/>;
}

export default function TechOperationOperationsField(props: { name: string }) {
    return <FormField<ITechOperationModel>
            id={props.name}
            formName="base-option-edit-form"
            fieldLabel="TechOperationsShow.fields.operations"
            type="nested_list"
            fieldName={props.name}
            config={{
                label: 'TechOperationsShow.fields.operations'
            }}
            fieldElement={ActualForm as any}
    />;
}
